var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 423.724h494.345a8.829 8.829 0 0 0 8.828-8.828V311.908L4.85 422.664c1.209.624 2.523 1.06 3.978 1.06z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 88.276H8.828A8.829 8.829 0 0 0 0 97.104v317.792c0 1.972.769 3.699 1.862 5.169L170.667 88.276z",
    fill: "#41479b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.613 421.158l338.72-332.881H170.667L1.862 420.065c.264.356.436.78.751 1.093z",
    fill: "#ffe15a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H341.333L2.613 421.158c.367.364.858.569 1.284.865L512 200.092V97.104a8.829 8.829 0 0 0-8.828-8.828z",
    fill: "#ff4b55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85 422.664l507.149-110.757V200.092L3.896 422.022c.317.22.609.466.954.642z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/sc.992bfa146e8271a4cff358358a0041d8.svg";
export { ForwardRef as ReactComponent };